module.exports = __webpack_public_path__ + "img/welcome_bg.2daaefed.jpg";